<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Justfone API Data: {{className}} - ID: {{id}}</h2>
  <mat-dialog-content class="dialog-content">
    <uim-json-viewer [json]="json" [expanded]="false"></uim-json-viewer>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" (click)="forceUpdate()" matTooltip="Force creates or updates the entity through the Justfone API">Force Update</button>
    <button mat-raised-button color="warn" (click)="forceDelete()" matTooltip="Force deletes the entity through the Justfone API">Force Delete</button>
    <button mat-raised-button color="accent" (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
</div>